module.exports = __webpack_public_path__ + "static/media/plus.e99bc541.png";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/plus.png
// module id = 93
// module chunks = 0